import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">编辑精选91视频、97视频、51视频热门专题内容推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className="group relative rounded-2xl overflow-hidden bg-background-950 min-h-[320px] md:min-h-[380px] flex flex-col justify-end p-5 md:p-6 cursor-pointer border border-background-200/60 hover:border-primary-200/40 transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-background-800 via-background-900 to-background-950"></div>
              <div className="absolute inset-0 opacity-20">
                <div className="absolute top-6 right-6 w-20 h-20 rounded-full bg-primary-500/30 blur-3xl"></div>
                <div className="absolute bottom-10 left-6 w-16 h-16 rounded-full bg-accent-500/20 blur-3xl"></div>
              </div>

              <div className="relative z-10">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold font-heading text-background-50 mb-2 leading-snug">{item.title}</h3>
                <p className="text-sm text-background-300/60 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-1.5 mt-4 text-primary-400 text-sm font-medium">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}